// extracted by mini-css-extract-plugin
export default {"layout":"DashboardLayout-module__layout__Idvii","content":"DashboardLayout-module__content__Vbix1","collapsed":"DashboardLayout-module__collapsed__aIPgK"};